import PropTypes from 'prop-types';
import React from 'react';
import {map} from 'lodash';
import Label from 'shared/components/label';
import Dropdown from 'src/components/dropdown';

class DayDropdown extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    onChange: PropTypes.func,
    days: PropTypes.array,
    label: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    days: map(new Array(31), (val, index) => {
      const day = (index + 1).toString();
      return {_id: day, value: day, text: day};
    }),
    label: 'Day',
  };

  render() {
    const {days, onChange, label, required, disabled, value, error} = this.props;

    return (
      <Label required={required}>
        {label}
        <Dropdown
          required={required}
          options={days}
          value={value}
          error={error}
          cy="day-dropdown"
          testid="day-dropdown"
          onChange={onChange}
          disabled={disabled}
        />
      </Label>
    );
  }
}

export default DayDropdown;
